import { useMemo } from 'react'

import { Divider } from '@mui/material'

import { useTexts } from '../../useTexts'

import { form } from '../../formState'

export function Tolerance() {
  const texts = useTexts()

  const options = useMemo(
    () => [
      {
        value: '0',
        label: texts.toleranceMinsValue(),
      },
      {
        value: '10',
        label: texts.toleranceMinsValue(10),
      },
      {
        value: '20',
        label: texts.toleranceMinsValue(20),
      },
      {
        value: '30',
        label: texts.toleranceMinsValue(30),
      },
    ],
    [texts],
  )

  const isFieldVisible = form.useForm().fields.toleranceMins?.visible

  return (
    <>
      <form.SimpleSelect
        label={texts.toleranceMinsLabel}
        validateOn="focus blur"
        testId="toleranceMins"
        name="toleranceMins"
        options={options}
        helperText={texts.toleranceMinsHelperText}
      />
      {isFieldVisible && <Divider />}
    </>
  )
}
